var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1197 10.2376C17.1197 13.9478 14.1412 16.9476 10.4768 16.9476C6.81249 16.9476 3.83398 13.9478 3.83398 10.2376C3.83398 6.52733 6.81249 3.52759 10.4768 3.52759C14.1412 3.52759 17.1197 6.52733 17.1197 10.2376Z",
    fill: "#CDB65C",
    stroke: "#B49E49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8075 8.60704C12.2673 8.60704 12.6401 8.20977 12.6401 7.71977C12.6401 7.22977 12.2673 6.83252 11.8075 6.83252C11.3475 6.83252 10.9746 7.22979 10.9746 7.71977C10.9746 8.20977 11.3475 8.60704 11.8075 8.60704Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1774 8.35183C12.6993 9.06545 12.059 9.14809 11.37 8.71228C11.3231 8.68266 11.115 8.5605 11.0689 8.53133C9.96055 7.83025 8.85346 8.10518 8.11101 9.21299C7.79551 9.68416 8.52521 10.1308 8.83718 9.66508C9.22078 9.09272 9.70856 8.9271 10.242 9.10839C9.96888 9.61357 9.73007 10.1157 9.39308 10.8291C9.05602 11.5424 8.31182 12.1121 7.59675 11.6666C7.08078 11.3452 6.61548 12.135 7.1299 12.4553C8.10614 13.0632 9.2508 12.69 9.83515 11.8997C9.85542 11.9113 9.87684 11.9217 9.90034 11.9304C10.3777 12.1076 11.0035 12.5794 11.1941 12.7466C11.3848 12.9138 11.7123 13.7656 11.9068 14.1936C12.1427 14.7129 12.9046 14.3347 12.6678 13.8132C12.4474 13.3276 12.0773 12.3585 11.7887 12.1133C11.5572 11.9166 11.1077 11.5506 10.7264 11.343C10.9844 10.8107 11.2529 10.2841 11.5356 9.76666C12.4368 10.0609 13.2934 9.71431 13.9034 8.80381C14.2192 8.33271 13.4896 7.8861 13.1774 8.35183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitCoin);
export default __webpack_public_path__ + "static/media/FitCoin.9b4c3c0cdd0cd69eeea2e593c222f3e9.svg";
export { ForwardRef as ReactComponent };